import { render, staticRenderFns } from "./BreadcrumbNav.vue?vue&type=template&id=c4b0b9f2&scoped=true&"
import script from "./BreadcrumbNav.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbNav.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbNav.vue?vue&type=style&index=0&id=c4b0b9f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b0b9f2",
  null
  
)

export default component.exports